// Silence console output in production builds to prevent info leaks via DevTools.
// Imported as the first module in index.js so it runs before any other code.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  // Keep console.error for critical runtime errors
}
